// extracted by mini-css-extract-plugin
module.exports = {"container":"ServiceHeader_container__i7GUH","title":"ServiceHeader_title__838fs","description":"ServiceHeader_description__HEnP5"};